<template>
  <div>
    <kst-output print-mode field="ClientID" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="Destination" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="ShipmentFee" :data="details" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../DlvCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>